import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import FSIcon from '@/components/FSIcon.vue'
import firebase from 'firebase/app'

Vue.config.productionTip = true
Vue.component('FSIcon', FSIcon)

let app = ''

Vue.directive('focus', {
  inserted: function(el) {
    el.focus()
  }
})

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
